module.exports = __webpack_public_path__ + "media/images/sp/plans/icon4-4e9b63c2bfa6046fe53a9138e61c7409.svg";